import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { creationValidator } from '@/modules/game/match/model/validator';
import { ROUTE_NAME_GAME } from '@/modules/game/router';
import { gameService } from '@/services/game';
import useVuelidate from '@vuelidate/core';
import { useMixins } from './mixins';

export function useGameMatchAdd() {
    const router = useAppRouter();

    const { fetch, model } = useMixins();

    const v$ = useVuelidate(creationValidator, model);

    const actions = {
        create: useCrudActions().excuteAndNotify({
            validator: v$,
            request: () =>
                gameService.match.create(
                    model.variantId,
                    model.name,
                    model.type,
                    model.maxRound,
                    model.maxPoint,
                    model.levelTimeout,
                    model.findingMatchTimeout,
                    model.winLoseGroup,
                    model.allowInvitation,
                    model.tableCreditRatio,
                    model.costs,
                    model.costStates,
                    model.potRatePercents,
                    model.potRateWeights
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_GAME.MATCH.INDEX, query: { variantId: model.variantId } })
        })
    };

    return { model, v$, fetch, actions };
}
